import * as reactIntl from 'react-intl';

import { yup } from '»utils/form';

export const repreFormValidation = (mainFormFields) => {
  const intl = reactIntl.useIntl();

  const requiredFieldMessage = intl.formatMessage({
    id: 'TRLT_UI-REQUIRED_FIELD',
  });

  const fieldMustBePercentage = intl.formatMessage({
    id: 'TRLT_UI-PERCENTAGE_FIELD',
  });

  const fieldMustBeIntegerPercentage = intl.formatMessage({
    id: 'TRLT_UI-INTEGER_PERCENTAGE_FIELD',
  });

  const fieldMustBeNumber = intl.formatMessage({
    id: 'TRLT_UI-NUMBER_FIELD',
  });

  const fieldCanNotHaveSpaces = intl.formatMessage({
    id: 'TRLT_UI-NO_SPACES_ALLOW',
  });

  const getFieldObligation = (fieldName) =>
    mainFormFields
      .find((mainFormField) => mainFormField.name === 'representatives')
      .data[0].find((partnerField) => partnerField.name === fieldName)
      ?.isRequired;

  return yup.object().shape({
    representatives: yup.array().of(
      yup.object().shape({
        representative: yup.string().when([], {
          is: () => getFieldObligation('representative'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        beneficiary: yup.string().when([], {
          is: () => getFieldObligation('beneficiary'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repShare: yup.string().when([], {
          is: () => getFieldObligation('repShare'),
          then: () =>
            yup
              .string()
              .matches(/^(100|[1-9]?\d)$/, fieldMustBeIntegerPercentage)
              .required(requiredFieldMessage),
          otherwise: () =>
            yup
              .string()
              .matches(/^(100|[1-9]?\d)$/, fieldMustBeIntegerPercentage),
        }),
        repName: yup.string().when([], {
          is: () => getFieldObligation('repName'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repNationality: yup.string().when([], {
          is: () => getFieldObligation('repNationality'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repSecNationality: yup.string().when([], {
          is: () => getFieldObligation('repSecNationality'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repIdType: yup.string().when([], {
          is: () => getFieldObligation('repIdType'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repOtherIdType: yup.string().when(['repIdType'], {
          is: (repIdType) =>
            repIdType === 'OUTRO' && getFieldObligation('repOtherIdType'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repIdNum: yup.string().when([], {
          is: () => getFieldObligation('repIdNum'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repIdLocal: yup.string().when([], {
          is: () => getFieldObligation('repIdLocal'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repIdDate: yup.date().when([], {
          is: () => getFieldObligation('repIdDate'),
          then: () => yup.date().required(requiredFieldMessage),
          otherwise: () => yup.date(),
        }),
        repIdExpDate: yup.date().when([], {
          is: () => getFieldObligation('repIdExpDate'),
          then: () => yup.date().required(requiredFieldMessage),
          otherwise: () => yup.date(),
        }),
        repFatherName: yup.string().when([], {
          is: () => getFieldObligation('repFatherName'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repMotherName: yup.string().when([], {
          is: () => getFieldObligation('repMotherName'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repAddress: yup.string().when([], {
          is: () => getFieldObligation('repAddress'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repJob: yup.string().when([], {
          is: () => getFieldObligation('repJob'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repPostcodeDescr: yup.string().when([], {
          is: () => getFieldObligation('repPostcodeDescr'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repPostCode: yup.string().when([], {
          is: () => getFieldObligation('repPostCode'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repCountry: yup.string().when([], {
          is: () => getFieldObligation('repCountry'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repAmericanNationality: yup.string().when([], {
          is: () => getFieldObligation('repAmericanNationality'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repUsTaxId: yup.number('NUMBER').when(['repAmericanNationality'], {
          is: (repAmericanNationality) =>
            repAmericanNationality === 'Y' && getFieldObligation('repUsTaxId'),
          then: () =>
            yup
              .number('NUMBER')
              .typeError(fieldMustBeNumber)
              .noSpacesAllowed(fieldCanNotHaveSpaces)
              .required(requiredFieldMessage),
          otherwise: () =>
            yup
              .number('NUMBER')
              .typeError(fieldMustBeNumber)
              .noSpacesAllowed(fieldCanNotHaveSpaces),
        }),
        repRole: yup.string().when([], {
          is: () => getFieldObligation('repRole'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repShareholding: yup.string().when([], {
          is: () => getFieldObligation('repShareholding'),
          then: () =>
            yup
              .string()
              .matches(/^(100|(\d{1,2}(\.\d{1,2})?))$/, fieldMustBePercentage)
              .required(requiredFieldMessage),
          otherwise: () =>
            yup
              .string()
              .matches(/^(100|(\d{1,2}(\.\d{1,2})?))$/, fieldMustBePercentage),
        }),
        repPpe: yup.string().when([], {
          is: () => getFieldObligation('repPpe'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repPpeFamily: yup.string().when([], {
          is: () => getFieldObligation('repPpeFamily'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repPpeKinshipDeg: yup.string().when(['repPpeFamily'], {
          is: (repPpeFamily) =>
            repPpeFamily === 'Y' && getFieldObligation('repPpeKinshipDeg'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repPpeRelationship: yup.string().when([], {
          is: () => getFieldObligation('repPpeRelationship'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
        repIncomeSource: yup.string().when([], {
          is: () => getFieldObligation('repIncomeSource'),
          then: () => yup.string().required(requiredFieldMessage),
          otherwise: () => yup.string(),
        }),
      }),
    ),
  });
};
